import { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import DotPulseLoading from "../../components/Loading/DotPulseLoading";
import { useNavigate } from "react-router-dom";
import { encryptData } from "../../utils/crypto";
import { AuthContext } from "../../auth/AuthContext";
import { Alert, AlertTitle, Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function TCCallback() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const processed = useRef(false);

  // useEffect(() => {
  //   const urlParams = new URLSearchParams(location.search);
  //   const token = urlParams.get("token");
  //   const code = urlParams.get("code");
  //   const errorParam = urlParams.get("error");

  //   if (errorParam) {
  //     setError("Terjadi kesalahan saat proses login.");
  //     setLoading(false);
  //     return;
  //   }

  //   if (token) {
  //     // === CASE: SSO Token ===
  //     axios
  //       .post(
  //         `${process.env.REACT_APP_API_BASE_URL}/auth/sso/callback`,
  //         {
  //           token,
  //         },
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`, // Tambahkan Authorization header
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         const { user, token } = res.data.data;
  //         // Simpan token jika dibutuhkan
  //         localStorage.setItem("token", token);
  //         const encrypted = encryptData(user);
  //         localStorage.setItem("user", encrypted);
  //         login(token, user);
  //         navigate("/dashboard");
  //       })
  //       .catch(() => {
  //         setError(
  //           "We were unable to verify your session. Please try again or contact support."
  //         );
  //         setLoading(false);
  //         setTimeout(() => {
  //           navigate("/login");
  //         }, 10000);
  //       });
  //   } else if (code) {
  //     // === CASE: Google OAuth Code ===
  //     axios
  //       .post(`${process.env.REACT_APP_API_BASE_URL}/auth/google`, { code })
  //       .then((response) => {
  //         const { user, token, registered } = response.data;

  //         if (registered) {
  //           localStorage.setItem("token", token);
  //           const encrypted = encryptData(user);
  //           localStorage.setItem("user", encrypted);
  //           login(token, user);
  //           navigate("/dashboard");
  //         } else {
  //           navigate("/sign-up", { state: { googleData: user } });
  //         }
  //       })
  //       .catch(() => {
  //         setError("Failed to process Google OAuth.");
  //         setLoading(false);
  //       });
  //   } else {
  //     setError("No login data found.");
  //     setLoading(false);
  //   }
  // }, [location.search, login, navigate]);

  useEffect(() => {
    // Gunakan ref untuk menandai sudah diproses

    const handleAuth = async () => {
      if (processed.current) return;
      processed.current = true;

      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");
      const code = urlParams.get("code");
      const errorParam = urlParams.get("error");

      // Bersihkan URL segera setelah mengambil parameter
      window.history.replaceState(null, null, window.location.pathname);

      if (errorParam) {
        setError("Terjadi kesalahan saat proses login.");
        setLoading(false);
        return;
      }

      try {
        if (token) {
          // Handle SSO Login
          const res = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/auth/sso/callback`,
            { token },
            { headers: { Authorization: `Bearer ${token}` } }
          );

          const { user, token: responseToken } = res.data.data;
          localStorage.setItem("token", responseToken);
          localStorage.setItem("user", encryptData(user));
          login(responseToken, user);
          navigate("/dashboard", { replace: true });
        } else if (code) {
          // Handle Google Login
          const response = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/auth/google`,
            { code }
          );

          const { user, token, registered } = response.data;
          if (registered) {
            localStorage.setItem("token", token);
            localStorage.setItem("user", encryptData(user));
            login(token, user);
            navigate("/dashboard", { replace: true });
          } else {
            navigate("/sign-up", {
              state: { googleData: user },
              replace: true,
            });
          }
        } else {
          setError("No login data found.");
          setLoading(false);
        }
      } catch (error) {
        const errorMessage = token
          ? "We were unable to verify your session. Please try again or contact support."
          : "Failed to process Google OAuth.";

        setError(errorMessage);
        setLoading(false);

        if (token) {
          setTimeout(() => navigate("/login", { replace: true }), 10000);
        }
      }
    };

    handleAuth();

    // Cleanup function
    return () => {
      processed.current = true;
    };
  }, [login, navigate]); // Hanya dependensi yang diperlukan

  if (loading) return <DotPulseLoading />;
  if (error)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "75vh",
          px: 2,
        }}
      >
        <Alert
          severity="error"
          icon={<ErrorOutlineIcon fontSize="inherit" />}
          sx={{
            maxWidth: 400,
            width: "100%",
            boxShadow: 3,
            borderRadius: 2,
          }}
        >
          <AlertTitle>Authentication Failed</AlertTitle>
          {error}
        </Alert>
      </Box>
    );

  return null;
}
